import {Rectangle} from 'pixi.js';

export interface IFlexInnerItem {
    setPositionByAxis: (mainAxisPosition: number, crossAxisPosition: number) => void;
    sizeByAxis: SizeByAxis;
    getArea: () => Rectangle;
}

type SizeByAxis = {main: number; cross: number;};

export class FlexInnerItem implements IFlexInnerItem {
    protected isRowDirection: boolean;
    protected area: Rectangle = new Rectangle();

    constructor(direction: 'row' | 'column', width: number, height: number) {
        this.isRowDirection = direction === 'row';
        this.area.height = height;
        this.area.width = width;
    }

    public get sizeByAxis(): SizeByAxis {
        const {isRowDirection, area} = this;

        return isRowDirection ? {main: area.width, cross: area.height} : {main: area.height, cross: area.width};
    }

    public setPositionByAxis(mainAxisPosition: number, crossAxisPosition: number): void {
        this.area.x = this.isRowDirection ? mainAxisPosition : crossAxisPosition;
        this.area.y = this.isRowDirection ? crossAxisPosition : mainAxisPosition;
    }

    public getArea(): Rectangle {
        return this.area;
    }
}